import { render, staticRenderFns } from "./orderBoard.vue?vue&type=template&id=389781f3&scoped=true&"
import script from "./orderBoard.vue?vue&type=script&lang=js&"
export * from "./orderBoard.vue?vue&type=script&lang=js&"
import style0 from "./orderBoard.vue?vue&type=style&index=0&id=389781f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389781f3",
  null
  
)

export default component.exports